import { Page } from '~/_shared/constants/routes';

export const ADMIN_MAP_PAGES = new Set([Page.ADMIN_MAP, Page.ADMIN_DATA]);
export const ALL_MAP_RELATED_PAGES = new Set([...ADMIN_MAP_PAGES, Page.PRESENTATIONAL]);
